<template>
  <div class="wrapper">
    <div class="headerTop">
      <a-icon type="experiment" /><span>{{data.object.name}} 配料</span>
    </div>
    <div class="content">
      <div class="contentHeader">
        <div class="detailUnit">
          <div>重量/g</div>
          <div>时间/s</div>
        </div>
        <div
          v-for="item in data.list"
          :key="item.index"
          style="display: flex; flex-direction: column; align-items: center"
        >
          <Cone :rawMaterial="item.rawMaterial"></Cone>
          <div class="weight">
            {{ item.weight }}
          </div>
          <div class="time">
            {{ item.time }}
          </div>
        </div>
      </div>
      <div class="contentBottom">
        <div class="machine">混料机</div>
        <div><img src="~assets/img/左箭头.jpg" alt="" /></div>
        <div class="middle">
          <div class="middleDetail">
            <a-icon type="dashboard" />
            <div>搅拌设定时间：{{data.object.time}}/s</div>
          </div>
          <div class="middleDetail">
            <a-icon type="dashboard" />
            <div>搅拌设定时间：{{data.object.time}}/s</div>
          </div>
        </div>
        <div class="bottom">
          <div class="queryButton">
            <a-button type="primary" size="small">搅拌时间记录查表</a-button>
          </div>
          <div class="currentNum">当天配料付数:{{data.object.currentNum}}</div>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import Cone from "./detailModule/cone.vue";
export default {
  name: "dosing",
  data() {
    return {
      // list: [
      //   { rawMaterial: "长白石", weight: 20, time: 5 },
      //   { rawMaterial: "方解石", weight: 20, time: 5 },
      //   { rawMaterial: "小料", weight: 20, time: 5 },
      //   { rawMaterial: "纯碱", weight: 20, time: 5 },
      //   { rawMaterial: "石英砂", weight: 20, time: 5 },
      // ],
      // object: {
      //   time: 5,
      //   currentNum:100,
      //   name:'3号窑炉'
      // },
    };
  },
  components: {
    Cone,
  },
  props:{
    data:{
      type:Object
    }
  }
};
</script>
<style scoped>
.headerTop {
  padding: 10px;
  width: 180px;
  color: #fff;
}
.headerTop span {
  font-size: 18px;
  padding-right: 30px;
  padding-left: 10px;
  color: #d4d5d6;
  font-size: 18px;
}
.wrapper {
  margin-top: 10px;
  width: 100%;
  background-color: #202834;
  height: 450px;
}
.content {
  height: 300px;
  width: 100%;
  padding-left: 10px;
}
.contentHeader {
  /* margin-top: 20px; */
  width: 90%;
  display: flex;
  justify-content: space-around;
  color: #c8c9cd;
  /* height: 300px; */
  align-items: flex-end;
}
.weight,
.time {
  width: 30px;
  background-color: #227ace;
  border-radius: 5px;
  margin-top: 5px;
}
.detailUnit {
  width: 40px;
}
.machine {
  width: 30px;
  height: 90px;
  border: 1px solid #2b6987;
  font-size: 15px;
  color: #fff;
}
.contentBottom {
  display: flex;
  align-items: center;
  height: 200px;
  color: rgb(228, 228, 228);
}
.queryButton {
  padding-bottom: 30px;
}
.middleDetail {
  margin-top: 5px;
  border: 1px solid #227ace;
  padding: 5px;
}
.currentNum {
  width: 127px;
  border: 1px solid #498bce;
  border-radius: 2px;
}
.bottom {
  padding-left: 15px;
  display: flex;
  flex-direction: column;
  justify-content: center;
  height: 60px;
  align-items: center;
}
</style>


// WEBPACK FOOTER //
// src/components/test10Children/dosing.vue